import {getTranslations} from '../../selectors';
import {connect} from 'react-redux';
import tripboardActions from '../actions';
import Tripboards from './tripboards';
import {withPAR} from '../../components/Timing';

function mapStateToProps(state) {
    return {
        translations: getTranslations(state)
    };
}

const mapDispatchToProps = {
    onDelete: tripboardActions.deleteTripboard
};

const TripboardsContainer = withPAR(connect(mapStateToProps, mapDispatchToProps)(Tripboards));

export default TripboardsContainer;



// WEBPACK FOOTER //
// ./src/universal/tripboard/components/tripboards-container.js